<template>
	<div>
		<ParamResult ref="paramResult"></ParamResult>
		<div class="filter mt1x">
			<div class="tableSys mb1x vaM_E">
				<div class="pl1x dpIB_E vaM_E">
					<Select
						:name="'instructionsStatus'"
						:class="{ sizeS: true }"
						:list="instructionsStatusList"
						@Click="instructionsStatusSelect"
						:keyMap="{ text: 'name', value: 'value' }"
					></Select>
				</div>
			</div>
		</div>
		<div class="tableScope bgContent">
			<div
				class="table table-5x tra-fast posR"
				fillHeight="lastHeight,-.myListHeight02"
			>
				<Loading ref="loading"></Loading>
				<div id="readerRecordList" class="cb" v-show="list.length > 0">
					<div
						class="scrollHide tra-fast fL"
						:style="{ width: '16em' }"
						scrollFloatX="false"
						fillHeight="lastHeight,-.myListHeight02"
					>
						<div
							class="tableSys head noSelect b cField bdLight-bottom tra-fast_E"
							scrollFloatY="false"
						>
							<div
								class="pl2x-imp sequence"
								:class="{ cMain: orderProperty == 3 }"
								:title="
									getLanguageStr('word1776', '指令发送时间')
								"
								@click="order(2)"
							>
								<span>{{
									getLanguageStr("word1776", "指令发送时间")
								}}</span>
								<span
									:sequence="
										orderProperty == 2 ? orderedsc : ''
									"
								></span>
							</div>
						</div>
						<div
							class="fixedScrollBar scrollY tra-fast"
							fillHeight="lastHeight,-.myListHeight02"
							scroll="{'group':'a'}"
						>
							<table>
								<thead class="head-token">
									<tr>
										<th></th>
									</tr>
								</thead>
								<tbody
									class="bdLight-bottom_E emptyToken_EE textCut_EE"
								>
									<tr
										v-for="(record, index) in list"
										:key="record.orderId"
									>
										<td
											class="pl2x-imp"
											:title="
												record.createTime
													? timeFormat(
															record.createTime /
																1000,
															'utc',
															'%Y/%m/%d %H:%M:%S UTC',
															{ offset: timezone }
													  )
													: '--'
											"
										>
											<div>
												{{
													record.createTime
														? timeFormat(
																record.createTime /
																	1000,
																"utc",
																"%H:%M:%S",
																{
																	offset: timezone
																}
														  )
														: "--"
												}}
											</div>
											<div class="cSub">
												{{
													record.createTime
														? timeFormat(
																record.createTime /
																	1000,
																"utc",
																"%Y/%m/%d UTC",
																{
																	offset: timezone
																}
														  )
														: "--"
												}}
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>

					<div scroll="{'axis':'x'}">
						<div
							class="tableSys head noSelect b cField bdLight-bottom"
							:style="{
								'min-width':
									stage.setting.system.autoColumnWidth[0] *
										column.length +
									stage.setting.system.autoColumnWidth[1]
							}"
							scrollFloatY="false"
						>
							<div :title="$t('word1501', ['指令名称'])">
								{{ $t("word1501", ["指令名称"]) }}
							</div>
							<div
								:title="
									getLanguageStr(
										'device_management69',
										'指令类型'
									)
								"
							>
								{{
									getLanguageStr(
										"device_management69",
										"指令类型"
									)
								}}
							</div>
							<div :title="$t('word1502', ['输入项'])">
								{{ $t("word1502", ["输入项"]) }}
							</div>
							<div :title="$t('device254', ['返回结果'])">
								{{ $t("device254", ["返回结果"]) }}
							</div>
							<div
								:title="getLanguageStr('word1777', '指令状态')"
							>
								{{ getLanguageStr("word1777", "指令状态") }}
							</div>
							<div
								style="overflow:inherit"
								:title="$t('task39', ['失败原因'])"
							>
								{{ $t("task39", ["失败原因"])
								}}<Help
									:code="'reasonFailureDetail'"
									:btnClose="false"
									class="ml05x"
								></Help>
							</div>
							<div :title="$t('word788', ['操作人'])">
								{{ $t("word788", ["操作人"]) }}
							</div>
							<div
								:class="{ cMain: orderProperty == 3 }"
								class="sequence"
								:title="getLanguageStr('plant56', '反馈时间')"
								@click="order(3)"
							>
								<span>{{
									getLanguageStr("plant56", "反馈时间")
								}}</span>
								<span
									:sequence="
										orderProperty == 3 ? orderedsc : ''
									"
								></span>
							</div>
						</div>
						<div
							class="fixedScrollBar scrollY tra-fast"
							fillHeight="lastHeight,-.myListHeight02"
							scroll="{'group':'a'}"
						>
							<table
								:style="{
									'min-width':
										stage.setting.system
											.autoColumnWidth[0] *
											column.length +
										stage.setting.system.autoColumnWidth[1]
								}"
							>
								<thead class="head-token">
									<tr>
										<th></th>
										<th></th>
										<th></th>
										<th></th>
										<th></th>
										<th></th>
										<th></th>
									</tr>
								</thead>
								<tbody
									class="bdLight-bottom_E emptyToken_EE textCut_EE"
								>
									<tr
										v-for="(record, index) in list"
										:key="record.orderId"
									>
										<td :title="getOrderName(record)">
											{{ getOrderName(record) }}
										</td>
										<td
											:title="
												record.operationTypeName || '--'
											"
										>
											{{
												record.operationTypeName || "--"
											}}
										</td>

										<td
											v-if="record.operationType !== 5"
											:title="getEntries(record).text"
											:class="
												getEntries(record).className
											"
											@click="
												openResult(
													getEntries(record).params,
													record
												)
											"
										>
											{{ getEntries(record).text }}
										</td>
										<td v-else>
											<a
												class="cMain"
												@click="moreInput(record)"
												>{{
													record.extendWeb &&
													JSON.parse(record.extendWeb)
														.inputParam &&
													Object.keys(
														JSON.parse(
															record.extendWeb
														).inputParam
													).length > 0
														? getLanguageStr(
																"device_management60",
																"查看更多"
														  )
														: "--"
												}}</a
											>
										</td>

										<td
											v-if="
												record.operationType !== 4 &&
													record.operationType !== 5
											"
											:title="getResult(record).text"
											:class="getResult(record).className"
											@click="
												openResult(
													getResult(record).params,
													record
												)
											"
										>
											{{ getResult(record).text }}
										</td>
										<td v-else>
											<a
												class="cMain"
												@click="moreResult(record)"
												>{{
													record.analysisResult
														? getLanguageStr(
																"device_management60",
																"查看更多"
														  )
														: "--"
												}}</a
											>
										</td>
										<td
											:title="
												record.status
													? getTypeText(
															record.status,
															'deviceOrderStatus'
													  )
													: '--'
											"
										>
											{{
												record.status
													? getTypeText(
															record.status,
															"deviceOrderStatus"
													  )
													: "--"
											}}
										</td>
										<td
											:title="
												record.error
													? getTypeText(
															record.error,
															'errorReason'
													  )
													: '--'
											"
										>
											{{
												record.error
													? getTypeText(
															record.error,
															"errorReason"
													  )
													: "--"
											}}
										</td>
										<td
											:title="record.createByName || '--'"
										>
											{{ record.createByName || "--" }}
										</td>
										<td
											:title="
												record.updateTime
													? timeFormat(
															record.updateTime /
																1000,
															'utc',
															'%Y/%m/%d %H:%M:%S UTC',
															{ offset: timezone }
													  )
													: '--'
											"
										>
											<div>
												{{
													record.updateTime
														? timeFormat(
																record.updateTime /
																	1000,
																"utc",
																"%H:%M:%S",
																{
																	offset: timezone
																}
														  )
														: "--"
												}}
											</div>
											<div class="cSub">
												{{
													record.updateTime
														? timeFormat(
																record.updateTime /
																	1000,
																"utc",
																"%Y/%m/%d UTC",
																{
																	offset: timezone
																}
														  )
														: "--"
												}}
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>

					<!--<div class="scrollHide tra-fast fL"
					:style="{'width':stage.setting.system.autoColumnWidth[0]*floatColumn.length+stage.setting.system.autoColumnWidth[1]}"
					scrollFloatX="false" fillHeight="lastHeight,-.myListHeight02">
					<div class="tableSys head noSelect b cField bdLight-bottom tra-fast_E" scrollFloatY="false">
						<div class="pl2x-imp sequence" :class="{cMain:orderProperty==3}" :title="getLanguageStr('word1776','指令发送时间')" @click="order(2)">
							<span>{{getLanguageStr('word1776','指令发送时间')}}</span>
							<span :sequence="orderProperty==2 ? orderDirection : ''"></span>
						</div>
					</div>
					<div class="fixedScrollBar scrollY tra-fast" fillHeight="lastHeight,-.myListHeight02" scroll="{'group':'a'}">
						<table>
							<thead class="head-token">
								<tr>
									<th></th>
								</tr>
							</thead>
							<tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
								<tr v-for="(record,index) in list" :key="index" @click.stop="view()">
									<td class="pl2x-imp" :title="record.createTime?timeFormat(record.createTime/1000,'inc','%Y/%m/%d %H:%M:%S'):'--'">
										<div>{{record.createTime?timeFormat(record.createTime/1000,'inc','%H:%M:%S'):'--'}}</div>
										<div class="cSub">{{record.createTime?timeFormat(record.createTime/1000,'inc','%Y/%m/%d'):'--'}}</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div scroll="{'axis':'x'}">
					<div class="tableSys head noSelect b cField bdLight-bottom"
						:style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}"
						scrollFloatY="false">
												<div :title="$t('word1501',['指令名称'])">{{$t('word1501',['指令名称'])}}</div>
						<div :title="getLanguageStr('device_management69','指令类型')">{{getLanguageStr('device_management69','指令类型')}}</div>
						<div :title="$t('word1502',['输入项'])">{{$t('word1502',['输入项'])}}</div>
						<div :title="getLanguageStr('word1777','指令状态')">{{getLanguageStr('word1777','指令状态')}}</div>
						<div :title="$t('word788',['操作人'])">{{$t('word788',['操作人'])}}</div>
						<div :class="{cMain:orderProperty==3}" class="sequence" :title="getLanguageStr('plant56','反馈时间')" @click="order(3)">
							<span>{{getLanguageStr('plant56','反馈时间')}}</span>
							<span :sequence="orderProperty==3 ? orderDirection : ''"></span>
						</div>
					</div>
					<div class="fixedScrollBar scrollY tra-fast" fillHeight="lastHeight,-.myListHeight02" scroll="{'group':'a'}">
						<table :style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}">
							<thead class="head-token">
								<tr>
									<th></th>
									<th></th>
									<th></th>
									<th></th>
									<th></th>
									<th></th>
								</tr>
							</thead>
							<tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
								<tr v-for="(record,index) in list" :key="index">
																	<td>{{record.orderName || '--'}}</td>
									<td>{{record.operationTypeName || '--'}}</td>
									<td>{{record.inputParam || '--'}}</td>
									<td>{{record.status?getTypeText(record.status,'instructionsStatus'):'--'}}</td>
									<td>{{record.createByName || '--'}}</td>
									<td :title="record.updateTime?timeFormat(record.updateTime/1000,'inc','%Y/%m/%d %H:%M:%S'):'--'">
										<div>{{record.updateTime?timeFormat(record.updateTime/1000,'inc','%H:%M:%S'):'--'}}</div>
										<div class="cSub">{{record.updateTime?timeFormat(record.updateTime/1000,'inc','%Y/%m/%d'):'--'}}</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>-->
				</div>
				<no-result v-show="list.length == 0"></no-result>
			</div>
			<div
				class="tableBatch bgContent cSub tra-fast myListHeight02"
				:class="{ disable: !list.length }"
			>
				<Pagination
					class="ml2x"
					:pagination="pagination"
					:getList="_getList"
				></Pagination>
			</div>
		</div>
	</div>
</template>
<script>
import * as lib from "@/util/lib.js";
import * as orderConfig from "@/util/deviceOrderConfig";
import Help from "@/components/common/Help.vue";
import { getLanguage } from "@/util/deviceOrderConfig.js";
import * as orderApi from "@/api/device/order.js";
import ParamResult from "@/view/device/device/part/ParamResult.vue";

export default {
	name: "readerRecord",
	components: { Help, ParamResult },
	props: {
		deviceId: {
			type: [String, Number],
			default: null
		},
		deviceSn: {
			type: [String, Number],
			default: null
		},
		timezone: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			loadingMoblie: false,
			finished: false,
			refreshing: false,
			pagination: {}, // 分页数据
			list: [],
			stage,
			maxPage: 1,
			terminal: 0, // 0为pc，1为移动端
			floatColumn: ["a"],
			column: ["1", "2", "3", "4", "5", "6"],
			orderProperty: 2, // 1:order_id,2:create_time,3:update_time
			orderDirection: 2, // 1:ASC,2:DESC
			orderedsc: "DESC",
			instructionsStatusList: [
				{
					value: null,
					name: getLanguageStr("cmd19", "全部"),
					def: getLanguageStr("word1777", "指令状态")
				}
			].concat(lib.getTypeText("", "deviceOrderStatus", true)), // 指令状态
			instructionsStatusSelected: ""
		};
	},
	methods: {
		timeFormat: lib.timeFormat,
		getLanguageStr,
		getTypeText: lib.getTypeText,
		setMobileChange(val) {
			if (val === 0) {
				this.instructionsStatusSelected = "";
			} else {
				this.instructionsStatusSelected = val;
			}

			this.onRefresh();
		},
		jugeEndPage() {
			if (this.pagination.total % this.pagination.request.size === 0) {
				this.maxPage =
					this.pagination.total / this.pagination.request.size;
			} else {
				this.maxPage = Math.ceil(
					(this.maxPage =
						this.pagination.total / this.pagination.request.size)
				);
			}
		},
		onRefresh() {
			this.$set(this.pagination.request, "page", 0);
			this.refreshing = true;
			// 清空列表数据
			this.finished = false;
			// 重新加载数据
			// 将 loading 设置为 true，表示处于加载状态
			this.loadingMoblie = true;
			this.onLoad();
		},
		onLoad() {
			// console.log("tttt");
			++this.pagination.request.page;
			this._getList().then(data => {
				this.jugeEndPage();
				setTimeout(() => {
					if (this.maxPage <= this.pagination.request.page)
						this.finished = true;
					else this.finished = false;
					this.loadingMoblie = false;
					this.refreshing = false;
					this.$forceUpdate();
				}, 0);
			});
		},
		getEntries(item) {
			if (item.operationType === 2) {
				// 单指令多参数
				let result = orderConfig.analyFunction(item) || {};
				if (result.values && result.values.length > 0) {
					return {
						text: getLanguageStr("device403", "点击查看"),
						className: "cMain curP",
						params: result.values
					};
				} else {
					return {
						text: this.analysisExt(item),
						className: null
					};
				}
			} else if (item.operationType === 3) {
				return {
					text: this.analysisExt(item),
					className: null
				};
			}
			return {
				text: "--",
				className: null
			};
		},
		getResult(item) {
			// 返回结果
			let result = orderConfig.analyFunction(item) || {};
			if (item.operationType == 1 || item.operationType == 3) {
				// 读取
				if (result.values && result.values.length > 0) {
					return {
						text: getLanguageStr("device403", "点击查看"),
						className: "cMain curP",
						params: result.values
					};
				}
				return {
					text: result.value,
					className: null
				};
			}
			return {
				text: "--",
				className: null
			};
		},
		openResult(data, record) {
			if (!data) return;
			const list = data.map(item => ({
				name: getLanguage(item.configInfo.subName[0], "子参数名"),
				value: item.value
			}));
			const title =
				record.operationType === 2
					? getLanguageStr("plant_detail141", "输入项")
					: getLanguageStr("device254", "返回结果");
			this.$refs.paramResult.show({
				list,
				title,
				terminal: this.terminal
			});
		},
		moreInput(record) {
			if (!record.extendWeb) return;
			let recordCopy = _.cloneDeep(record);
			recordCopy.extendWeb = JSON.parse(recordCopy.extendWeb);

			let group = recordCopy.groupCode.split(",");
			let cmdMaps = deviceConfigOption.rule.optionClass[group[0]].filter(
				item => {
					return group[1].split("_")[1] == item.code;
				}
			);
			let cmdList = cmdMaps[0].cmdList;
			let cmdMapres = cmdMaps[0].cmdMap;
			let inputArr = [];
			// console.log(record.extendWeb)
			// console.log(record.extendWeb.inputParam)
			for (let i in cmdList) {
				if (
					recordCopy.extendWeb.inputParam[cmdList[i].code] !=
					undefined
				) {
					// 抽出用到的
					inputArr.push(cmdList[i]);
				}
			}

			let Html = "";
			inputArr.forEach(item => {
				if (item.name && item.name.length) {
					let name = getLanguage(item.name[0], item.name[1]);
					let unit = "";
					let value = "";
					if (item.type === "input") {
						unit = item.unit
							? getLanguage(item.unit[0], item.unit[1])
							: "";
						value = recordCopy.extendWeb.inputParam[item.code].v;
					} else if (item.type === "time") {
						unit = "";
						value =
							recordCopy.extendWeb.inputParam[
								item.code
							].v.substring(0, 4) +
							"/" +
							recordCopy.extendWeb.inputParam[item.code].v
								.toString()
								.substring(4, 6) +
							"/" +
							recordCopy.extendWeb.inputParam[
								item.code
							].v.substring(6, 8) +
							" " +
							recordCopy.extendWeb.inputParam[
								item.code
							].v.substring(8, 10) +
							":" +
							recordCopy.extendWeb.inputParam[
								item.code
							].v.substring(10, 12) +
							":" +
							recordCopy.extendWeb.inputParam[
								item.code
							].v.substring(12, 14);
					} else if (item.type === "hm") {
						const hmResult =
							recordCopy.extendWeb.inputParam[item.code].v;
						value =
							hmResult.substring(0, 2) +
							":" +
							hmResult.substring(2, 4);
					} else if (item.type === "checkbox") {
						const checkboxResult = recordCopy.extendWeb.inputParam[
							item.code
						].v.split("");
						let htmlTel = "";
						checkboxResult.forEach((e, i) => {
							htmlTel += `<span class="mr1x"> ${getLanguage(
								item.cmdList[i].text[0],
								"选项名"
							)} </span><span>${getLanguage(
								e === item.cmdList[i].valMap.on.val
									? item.cmdList[i].valMap.on.text[0]
									: item.cmdList[i].valMap.off.text[0],
								"选项值"
							)}</span>${
								i === checkboxResult.length ? "" : "<br />"
							}`;
						});
						value = `<div class="dpIB">${htmlTel}</div>`;
					} else {
						let list = item.list.filter(items => {
							if (
								items.value ===
								recordCopy.extendWeb.inputParam[item.code].v
							) {
								value = getLanguage(
									items.text[0],
									items.text[1]
								);
								return item;
							}
						});
					}
					Html += `<div class='mb1x vaT_E'><span>${name}</span>:<span class='ml1x'>${value}${unit}</span></div>`;
				}
			});
			if (this.terminal === 0) {
				this.$notify(`<div class='cContent'>${Html}</div>`, {
					title:
						record.operationType == 4
							? getLanguageStr("device254", "返回结果")
							: getLanguageStr("device328", "指令内容")
				});
			} else {
				Dialog.alert({
					title:
						record.operationType == 4
							? getLanguageStr("device254", "返回结果")
							: getLanguageStr("device328", "指令内容"),
					message: Html,
					allowHtml: true,
					confirmButtonText: getLanguageStr("device220", "我知道了"),
					confirmButtonColor: "#2F72FA",
					className: " custDa",
					confirm: () => {
						Dialog.close();
					}
				});
			}
		},
		// 1成功
		moreResult(record) {
			let inputArr = [];
			// console.log(record.extendWeb)
			if (!record.analysisResult) return;
			let recordCopy = _.cloneDeep(record);
			recordCopy.analysisResult = JSON.parse(recordCopy.analysisResult);
			recordCopy.extendWeb = JSON.parse(recordCopy.extendWeb);

			let group = recordCopy.groupCode.split(",");
			let cmdMaps = deviceConfigOption.rule.optionClass[group[0]].filter(
				item => {
					return group[1].split("_")[1] == item.code;
				}
			);
			let cmdList = cmdMaps[0].cmdList;
			let cmdMapres = cmdMaps[0].cmdMap;
			// console.log(record.extendWeb.inputParam)
			if (record.operationType == 5) {
				for (let i in cmdList) {
					if (
						recordCopy.extendWeb.inputParam[cmdList[i].code] !=
						undefined
					) {
						inputArr.push(cmdList[i]);
					}
				}
			} else {
				for (let i in cmdList) {
					if (
						recordCopy.analysisResult[cmdList[i].code] != undefined
					) {
						inputArr.push(cmdList[i]);
					}
				}
			}

			// for(let i in recordCopy.extendWeb.inputParam){
			//  inputArr.push(i);
			// }
			let Html = "";
			let wrapHtml = "";
			inputArr.forEach(item => {
				if (!item) return;
				if (item.name && item.name.length) {
					let name = getLanguage(item.name[0], item.name[1]);
					let unit = "";
					let value = "";
					if (record.operationType == 4) {
						if (item.type === "input") {
							unit = item.unit
								? getLanguage(item.unit[0], item.unit[1])
								: "";
							value =
								(item.prefix ? item.prefix[0] : "") +
								recordCopy.analysisResult[item.code];
						} else if (item.type === "time") {
							unit = "";
							value =
								recordCopy.analysisResult[item.code].substring(
									0,
									4
								) +
								"/" +
								recordCopy.analysisResult[item.code]
									.toString()
									.substring(4, 6) +
								"/" +
								recordCopy.analysisResult[item.code].substring(
									6,
									8
								) +
								" " +
								recordCopy.analysisResult[item.code].substring(
									8,
									10
								) +
								":" +
								recordCopy.analysisResult[item.code].substring(
									10,
									12
								) +
								":" +
								recordCopy.analysisResult[item.code].substring(
									12,
									14
								);
						} else if (item.type === "hm") {
							const hmResult =
								recordCopy.analysisResult[item.code];
							value =
								hmResult.substring(0, 2) +
								":" +
								hmResult.substring(2, 4);
						} else if (item.type === "checkbox") {
							const checkboxResult = recordCopy.analysisResult[
								item.code
							].split("");
							let htmlTel = "";
							checkboxResult.forEach((e, i) => {
								htmlTel += `<span class="mr1x"> ${getLanguage(
									item.cmdList[i].text[0],
									"选项名"
								)} </span><span>${getLanguage(
									e === item.cmdList[i].valMap.on.val
										? item.cmdList[i].valMap.on.text[0]
										: item.cmdList[i].valMap.off.text[0],
									"选项值"
								)}</span>${
									i === checkboxResult.length ? "" : "<br />"
								}`;
							});
							value = `<div class="dpIB">${htmlTel}</div>`;
						} else {
							let list = item.list.filter(items => {
								if (
									items.value ===
									recordCopy.analysisResult[item.code]
								) {
									value = getLanguage(
										items.text[0],
										items.text[1]
									);
									return item;
								}
							});
						}
					} else {
						let Jsonp = recordCopy.analysisResult;
						value = Jsonp[item.code]
							? getLanguageStr("plant_detail168", "已成功")
							: getLanguageStr("plant_detail169", "已失败");
					}

					Html += `<div class='mb1x vaT_E' ><span>${name}</span>:<span class='ml1x'>${value}${unit}</span></div>`;
					wrapHtml = `<div id='batchparamalter' class="" scroll>${Html}</div>`;
				}
			});
			if (this.terminal === 0) {
				this.$notify(`<div class='cContent'>${wrapHtml}</div>`, {
					title: getLanguageStr("device254", "返回结果")
				});
			} else {
				Dialog.alert({
					title: getLanguageStr("device254", "返回结果"),
					message: wrapHtml,
					allowHtml: true,
					confirmButtonText: getLanguageStr("device220", "我知道了"),
					confirmButtonColor: "#2F72FA",
					className: " custDa",
					confirm: () => {
						Dialog.close();
					}
				});
			}
		},
		show(data) {
			orderConfig.loadContralOption(this._getList);
			// if(window.deviceConfigOption){
			// 	this._getList();
			// }
			// else{
			// 	orderApi.apiGetDeviceConfigOption().then(success=>{
			// 		this._getList();
			// 	});
			// }
			lib.fillHeight();
			lib.setScroll($(this.$el).find("#readerRecordList [scroll]"));
		},
		order(orderBy) {
			this.orderProperty = orderBy;
			if (this.orderDirection === 2) {
				this.orderedsc = "ASC";
				this.orderDirection = 1;
			} else {
				this.orderedsc = "DESC";
				this.orderDirection = 2;
			}
			this._getList();
		},
		instructionsStatusSelect(index) {
			this.instructionsStatusSelected = this.instructionsStatusList[
				index
			].value;
			this._getList();
		},
		getOrderName: function(data) {
			// 解析指令名称
			if (data.operationType == 3) return "--";
			return orderConfig.analyFunction(data).orderName;
		},
		analysisExt(item) {
			// 入参
			switch (
				item.operationType // 1:读取指令，2设置指令，3:自定义，4:批量读取，5:批量设置
			) {
				case 1: // 读取
					return "--";
					break;
				case 2:
					let result = orderConfig.analyFunction(item) || {};
					return result.value;
					break;
				case 3: // 自定义指令
					return orderConfig.analyFunction(item).orderName;
					break;
				case 4: // 读取
					return "--";
					break;
				default:
					return orderConfig.analyFunction(item);
					break;
			}
		},
		analysisResult(item) {
			// 返回结果
			let result = orderConfig.analyFunction(item) || {};
			if (item.operationType == 1 || item.operationType == 3) {
				// 读取
				return result.value;
			} else {
				return "--";
			}
		},
		_getList() {
			return new Promise(resolve => {
				if (this.terminal === 0) {
					this.$refs.loading.show();
				} else {
				}

				let queryParam = {
					deviceId: this.deviceId,
					deviceSn: this.deviceSn,
					// deviceType: this.deviceType,	// 2:普通设备
					// operationType: 12,	// 12:读取或设置
					orderType: 1, // 1:控制指令,2:升级指令
					ascDesc: this.orderDirection,
					orderBy: this.orderProperty,
					status: this.instructionsStatusSelected,
					page: this.pagination.request.page,
					size: this.pagination.request.size
				};
				orderApi.readRecordList(queryParam).then(
					res => {
						if (this.terminal === 0) {
							this.$refs.loading.hide();
						} else {
						}

						res.data.map((item, index) => {
							// item.updateTime = Number(item.updateTime) + mz.tz(this.timeZone)._offset * 60 * 1000
							// 指令名称
							if (item.groupCode) {
								let codeInfo = item.groupCode.split(",");
								item.orderName = orderConfig.getOrderName(
									codeInfo[1],
									codeInfo[0]
								);
							} else {
								// 自定义指令
								item.orderName = ["--"];
							}
							// 指令类型
							if (
								item.operationType == 1 ||
								item.operationType == 4
							) {
								item.operationTypeName = getLanguageStr(
									"word632",
									"读取"
								);
							} else if (
								item.operationType == 2 ||
								item.operationType == 5
							) {
								item.operationTypeName = getLanguageStr(
									"cmd16",
									"设置"
								);
							} else if (item.operationType == 3) {
								item.operationTypeName = getLanguageStr(
									"word639",
									"自定义"
								);
							}
							return item;
						});

						if (
							this.terminal === 0 ||
							this.pagination.request.page === 1
						) {
							this.list = res.data;
						} else {
							this.list.push(...res.data);
						}
						let { total } = res;
						this.pagination = { ...this.pagination, total };
						if (this.terminal === 0) {
							this.$refs.loading.hide();
						} else {
						}

						this.$nextTick(() => {
							resolve();
							lib.fillHeight();
							lib.setScroll(
								$(this.$el).find("#readerRecordList [scroll]")
							);
						});
					},
					error => {
						this.$refs.loading.hide();
					}
				);
			});
		}
	},
	created() {},
	mounted() {
		this.instructionsStatusList = this.instructionsStatusList.map(item => {
			if (item.value == 0) {
				return { ...item, statistic: { a: "", b: "" } };
			} else if (item.value == 100) {
				return { ...item, statistic: { a: "A68", b: "A6830" } };
			} else if (item.value == 300) {
				return { ...item, statistic: { a: "", b: "A6833" } };
			} else if (item.value == 400) {
				return { ...item, statistic: { a: "", b: "" } };
			} else if (item.value == 500) {
				return { ...item, statistic: { a: "A68", b: "A6832" } };
			} else if (item.value == 666) {
				return { ...item, statistic: { a: "A68", b: "A6831" } };
			} else {
				return item;
			}
		});
		// console.log(this.instructionsStatusList)
	}
};
</script>



// WEBPACK FOOTER //
// src/view/device/device/part/ReaderRecord.vue